// // ProtectedRoute.jsx

// import React from "react";
// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {

//   const token = localStorage.getItem("token");

//   return token ? children : <Navigate to="/admin-login" />;
// };

// export default ProtectedRoute;


import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {

  // Static login check without token
  const isLoggedIn = localStorage.getItem("isAdminLogin");

  if (isLoggedIn !== "true") {
    return <Navigate to="/admin-login" />;
  }

  return children;
};

export default ProtectedRoute;